var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewOff({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m2.783 21 18.75-18M8.964 19.051A9.985 9.985 0 0 0 12 19.5c4.1.069 8.258-2.813 10.824-5.637a1.663 1.663 0 0 0 0-2.226A20.568 20.568 0 0 0 19.75 8.88M14.413 6.282A9.549 9.549 0 0 0 12 6c-4.031-.067-8.2 2.752-10.821 5.635a1.663 1.663 0 0 0 0 2.226 20.8 20.8 0 0 0 2.6 2.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.25 12.75A3.749 3.749 0 0 1 12 9M15.75 12.749h0A3.75 3.75 0 0 1 12 16.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewOff);
export default __webpack_public_path__ + "static/media/view-off.32e1b0d3cb7949b1c3e4ff718004d3a1.svg";
export { ForwardRef as ReactComponent };